"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldConditionComparisonEnum = void 0;
var FormFieldConditionComparisonEnum;
(function (FormFieldConditionComparisonEnum) {
    FormFieldConditionComparisonEnum["nEqNum"] = "not_equal_num";
    FormFieldConditionComparisonEnum["nEqStr"] = "not_equal_str";
    FormFieldConditionComparisonEnum["EqNum"] = "equal_num";
    FormFieldConditionComparisonEnum["EqStr"] = "equal_str";
    FormFieldConditionComparisonEnum["Gt"] = "gt";
    FormFieldConditionComparisonEnum["Gte"] = "gte";
    FormFieldConditionComparisonEnum["Lt"] = "lt";
    FormFieldConditionComparisonEnum["Lte"] = "lte";
    FormFieldConditionComparisonEnum["IsNotNull"] = "is_not_null";
    FormFieldConditionComparisonEnum["IsNull"] = "is_null";
    FormFieldConditionComparisonEnum["IsFalse"] = "is_false";
    FormFieldConditionComparisonEnum["IsFalsy"] = "is_falsy";
    FormFieldConditionComparisonEnum["IsTrue"] = "is_true";
    FormFieldConditionComparisonEnum["IsTruly"] = "is_truly";
    FormFieldConditionComparisonEnum["IsEmpty"] = "is_empty";
    FormFieldConditionComparisonEnum["IsNotEmpty"] = "is_not_empty";
    FormFieldConditionComparisonEnum["IsUndefined"] = "is_undefined";
    FormFieldConditionComparisonEnum["IsDefined"] = "is_defined";
    FormFieldConditionComparisonEnum["AnyOfStr"] = "any_of_str";
    FormFieldConditionComparisonEnum["NoneOfStr"] = "none_of_str";
    FormFieldConditionComparisonEnum["AnyOfNum"] = "any_of_num";
    FormFieldConditionComparisonEnum["NoneOfNum"] = "none_of_num";
})(FormFieldConditionComparisonEnum = exports.FormFieldConditionComparisonEnum || (exports.FormFieldConditionComparisonEnum = {}));
